import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e7d4ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Algus kp:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lõpp kp:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sooritatud tunnid:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Algus kp:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lõpp kp:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sooritatud tunnid:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_iterator = _resolveComponent("v-data-iterator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_data_table, {
      class: "my-5 rounded bordered",
      headers: _ctx.tabel.paised,
      items: _ctx.elemendid,
      "items-per-page": _ctx.tabel.lehePikkus,
      loading: _ctx.tabel.laeb,
      "fixed-header": "",
      "item-key": "id"
    }, {
      bottom: _withCtx(() => []),
      [`item.algusKp`]: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value)), 1)
      ]),
      [`item.loppKp`]: _withCtx(({ value }) => [
        value
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value)), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      [`item.tunnid`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.tunnid) + "h " + _toDisplayString(item.minutid) + "min ", 1)
      ]),
      _: 2
    }, 1032, ["headers", "items", "items-per-page", "loading"]),
    _createVNode(_component_v_data_iterator, {
      class: "d-none d-lg-none",
      items: _ctx.elemendid,
      "item-value": "lahendiNr"
    }, {
      default: _withCtx(({ items }) => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "w-100",
              cols: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panels, {
                  variant: "accordion",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Sooritamise koht.: " + _toDisplayString(item.raw.sooritamiseKoht), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                lines: false,
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    title: _ctx.formateeriKuupaev(item.raw.algusKp)
                                  }, {
                                    title: _withCtx(({ title }) => [
                                      _hoisted_1,
                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  (item.raw.loppKp)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 0,
                                        title: _ctx.formateeriKuupaev(item.raw.loppKp)
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _hoisted_2,
                                          _createTextVNode(" " + _toDisplayString(title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, {
                                    title: item.raw.tunnid
                                  }, {
                                    title: _withCtx(({ title }) => [
                                      _hoisted_3,
                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_v_row, { class: "d-none" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                class: "w-100",
                cols: "auto",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "mx-auto" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" Sooritamise koht.: " + _toDisplayString(item.raw.sooritamiseKoht), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panels, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Sooritamise koht.: " + _toDisplayString(item.raw.sooritamiseKoht), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    lines: false,
                                    density: "compact"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        title: _ctx.formateeriKuupaev(item.raw.algusKp)
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _hoisted_4,
                                          _createTextVNode(" " + _toDisplayString(title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]),
                                      _createVNode(_component_v_list_item, {
                                        title: _ctx.formateeriKuupaev(item.raw.loppKp)
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _hoisted_5,
                                          _createTextVNode(" " + _toDisplayString(title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]),
                                      _createVNode(_component_v_list_item, {
                                        title: item.raw.tunnid
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _hoisted_6,
                                          _createTextVNode(" " + _toDisplayString(title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["items"])
  ], 64))
}